(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('settore', {
            parent: 'entity',
            url: '/settore',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.settore.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/settore/settores.html',
                    controller: 'SettoreController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settore');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('settore-detail', {
            parent: 'settore',
            url: '/settore/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.settore.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/settore/settore-detail.html',
                    controller: 'SettoreDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settore');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Settore', function($stateParams, Settore) {
                    return Settore.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'settore',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('settore-detail.edit', {
            parent: 'settore-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/settore/settore-dialog.html',
                    controller: 'SettoreDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Settore', function(Settore) {
                            return Settore.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('settore.new', {
            parent: 'settore',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/settore/settore-dialog.html',
                    controller: 'SettoreDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('settore', null, { reload: 'settore' });
                }, function() {
                    $state.go('settore');
                });
            }]
        })
        .state('settore.edit', {
            parent: 'settore',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/settore/settore-dialog.html',
                    controller: 'SettoreDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Settore', function(Settore) {
                            return Settore.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('settore', null, { reload: 'settore' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('settore.delete', {
            parent: 'settore',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/settore/settore-delete-dialog.html',
                    controller: 'SettoreDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Settore', function(Settore) {
                            return Settore.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('settore', null, { reload: 'settore' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
